import { deepmerge } from '@mui/utils';
import common from './common';

const edlenDev = deepmerge(common, {
  palette: {
    primary: {
          main: '#458045',
          light: '#92bc92',
          dark: '#2c612c',
    },
  },
  header: {
      background: '#458045',
    text: '#FFF',
    button: {
        background: '#294d29',
      text: '#FFF',
    },
      logo: 'edlenWhite',
  },
});

export default edlenDev;
